import { graphql } from '../../gql';

export const CATALOG_QUERY = graphql(`
  query Catalog($req: CatalogRequest!) {
    catalog(req: $req) {
      error
      schema {
        cols {
          name
          type
        }
      }
      data {
        num_rows
        cols {
          __typename
          ... on CatalogInt32Col {
            ints: vals
          }
          ... on CatalogFloat32Col {
            floats: vals
          }
          ... on CatalogStringCol {
            strings: vals
          }
          ... on CatalogBoolCol {
            bools: vals
          }
          ... on CatalogArrayInt32Col {
            intArrays: vals
          }
          ... on CatalogArrayFloat32Col {
            floatArrays: vals
          }
          ... on CatalogArrayStringCol {
            stringArrays: vals
          }
          ... on CatalogArrayBoolCol {
            boolArrays: vals
          }
        }
      }
    }
  }
`);
